import type { FC, RefObject } from 'react';
import React from 'react';

import { clsx } from 'clsx';

import './Spinner.css';

export interface SpinnerProps {
    /**
     * Ссылка на корневой DOM-элемент компонента.
     */
    innerRef?: RefObject<HTMLDivElement>;

    /**
     * Позиция индикатора загрузки.
     *
     * @default default
     */
    position?: 'default' | 'center';

    /**
     * Дополнительный класс.
     */
    className?: string;
    /**
     * Размер компонента
     *
     * @default m
     */
    size?: 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl';
}

/**
 * Индикатор загрузки. Отображает выполнение какого-то процесса, например загрузки сайта или медиа-файла.
 * @param {SpinnerProps}
 */
export const Spinner: FC<SpinnerProps> = ({
    className,
    innerRef,
    position = 'default',
    size = 'm',
    ...props
}) => (
    <div
        role={'progressbar'}
        {...props}
        ref={innerRef}
        className={clsx(
            'Spinner',
            `Spinner_size_${size}`,
            `Spinner_position_${position}`,
            className,
        )}
    />
);
